import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { OffsetPaginated } from 'types/pagination';
import { Stream } from 'types/stream';

import { useStreams, UseStreamsParams } from 'streams/hooks/useStreams';

export function useFileStreams(
  params?: UseStreamsParams,
  options?: UseQueryOptions<OffsetPaginated<Stream>, APIError>
) {
  return useStreams({
    params: {
      stream_types: ['file'],
      ...params,
    },
    ...options,
  });
}
